import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pass'
})
export class PassPipe implements PipeTransform {

  transform(value: string): any {
    const len = value.length
    let outtext = '';

    for(var i = 0; i < len; i++){
      outtext += '●';
    }
    return outtext;
  }

}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/yarukami/src/app/pipe/pass.pipe.ts